export { default as getBrands } from './getBrands';

export type { Brand, GetBrandsFunction, GetBrandsPayload } from './getBrands.type';
